import { injectable } from 'inversify';
import axiosClient from './axios-client';
import { ApiResponse } from '../utils/api-response.utils';
import { ERRORS } from '../constants/errors';

export interface CountryChannelOption {
  id: number;
  name: string;
}

export interface CountryChannelsResult {
  country: string;
  channels: CountryChannelOption[];
}

export interface BusinessUnitOption {
  id: string;
  name: string;
  isUniversal: boolean;
  isDefault: boolean;
}

@injectable()
export class OrganizationService {
  async getCountryChannels(
    countries?: string[]
  ): Promise<ApiResponse<CountryChannelsResult[]>> {
    try {
      const params =
        countries && countries.length > 0 ? { countries } : undefined;
      const response = await axiosClient.get<
        ApiResponse<CountryChannelsResult[]>
      >('/api/organization/country-channels', { params });
      return response.data;
    } catch (e: any) {
      if (e.response?.status === 403)
        throw new Error(ERRORS.missingSubscription);
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getBusinessUnits(): Promise<ApiResponse<BusinessUnitOption[]>> {
    try {
      const response = await axiosClient.get<ApiResponse<BusinessUnitOption[]>>(
        '/api/organization/business-units'
      );
      return response.data;
    } catch (e: any) {
      if (e.response?.status === 403)
        throw new Error(ERRORS.missingSubscription);
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
